$(document).ready(function () {
    fixedSearch();
});
$(window).scroll(function () {
    fixedSearch();
});

function fixedSearch() {
    if ($("form").is('.imageSearch-wrapperSearch')) {
        var st = $(window).scrollTop();

        element = $('.imageSearch-wrapperSearch input');

        var w = $(window).width();

        show_start = element.offset().top + element.innerHeight() - st - 50;

        show_end = element.offset().top - st - 80;

        if (show_start <= 0) {
            $('.headerSearchPc .headerSearch-form').addClass('active');
            if (w < 992 && w >= 768) {
                $('.headerLogo svg g.sing').css('display', 'none');
            }
        } else {
            $('.headerSearchPc .headerSearch-form').removeClass('active');
            if (w < 992 && w >= 768) {
                $('.headerLogo svg g.sing').css('display', 'block');
            }
        }
    }
    return true;
}


$(document).ready(function () {
    $('form.imageSearch-wrapperSearch').submit(function () {
        if (readMeta('services') == 1) {
            input_val = $('.imageSearch-wrapperSearch input').val();
            Services.search(input_val);
            return false;
        } else {
            return true;
        }
    });
});

